export default [
  {
    path: 'relatorios/gecom-promotores',
    name: 'gecom-promotores',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Gecom',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Novo Gecom' },
      ]
    }
  },
]